import React from "react";

const BlogCategory = ({ category }) => {
  return (
    <section className="section mb-5">
      <ul className="list-group z-depth-1">
        {category.map((category) => (
          <li className="list-group-item d-flex justify-content-between align-items-center">
            <a className="font-weight-bolder">{category.name}</a>
            <span className="badge teal badge-pill font-small">
              {category.count}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default BlogCategory;
